import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import de from './locales/de.json';

export type SupportedLanguage = 'en' | 'de';

const STORAGE_KEY = 'ffom-language';

function getStoredLanguage(): SupportedLanguage {
  const stored = window.localStorage.getItem(STORAGE_KEY);
  return stored === 'en' || stored === 'de' ? stored : 'de';
}

export function setLanguage(language: SupportedLanguage): void {
  window.localStorage.setItem(STORAGE_KEY, language);
  i18n.changeLanguage(language);
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
  },
  lng: getStoredLanguage(),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
